<script>
export default {
    data() {
        return {
            ano: (new Date()).getFullYear(),
        }
    },
}
</script>

<template>
  <div class="footer">
    <div>
      <strong>Gemini Sistemas</strong> &copy; {{ ano }} - build #1482 - Versão #8
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/Footer.vue